import { FontStyleEnums } from '@oy/uicore';
import classNames from 'classnames';
import React, { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import { makeId } from '../../../utilities/idComponent';
import Radio from '../../Components/SelectionControl/Radio/Radio';
import { Text } from '../../Contents';
import FieldContainer, { FontStyle } from '../FieldContainer/FieldContainer';
import styles from './RadioGroup.module.css';

interface RadioGroupOption {
  label: string;
  value: string | string[] | number;
  description?: string | React.ReactNode;
  additionalInput?: React.ReactNode;
  isDisabled?: boolean;
  id?: string;
}

export type RadioGroupProps = {
  options: RadioGroupOption[];
  errorMessage?: string;
  errorMessageId?: string;
  helpText?: string;
  isHorizontal?: boolean;
  label?: string | React.ReactNode;
  isDisabled?: boolean;
  labelStyle?: FontStyle;
  titleStyle?: FontStyleEnums;
  optionOrientation?: 'horizontal' | 'vertical';
  fullHeight?: boolean;
  isRequired?: boolean;
  leftColLength?: number;
  boldLabel?: boolean;
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

const RadioGroup = ({
  errorMessage,
  errorMessageId,
  helpText,
  isHorizontal,
  label,
  labelStyle,
  onChange,
  options,
  value,
  isDisabled = false,
  optionOrientation = 'vertical',
  fullHeight = true,
  isRequired = false,
  name,
  titleStyle = Text.Style.BodyMdSemibold,
  className,
  leftColLength,
  boldLabel,
}: RadioGroupProps) => {
  return (
    <FieldContainer
      isRequired={isRequired}
      name={name}
      className={classNames({ [styles.container]: fullHeight })}
      errorMessage={errorMessage}
      errorMessageId={errorMessageId}
      helpText={helpText}
      label={label}
      fontStyle={labelStyle || FontStyle.default}
      isHorizontal={isHorizontal}
      leftColLength={leftColLength}
      boldLabel={boldLabel}
    >
      <div className={classNames(styles[optionOrientation], className)}>
        {options.map((option, index) => {
          const key = `${option.label}${index}`;
          return (
            <Radio
              key={key}
              checked={value === option.value}
              description={option.description}
              additionalInput={option.additionalInput}
              onChange={onChange}
              title={option.label}
              titleStyle={titleStyle}
              isDisabled={option.isDisabled || isDisabled}
              value={option.value}
              name={name}
              id={makeId('radio', option.label, option.id)}
            />
          );
        })}
      </div>
    </FieldContainer>
  );
};

export default RadioGroup;
